<template>
  <div>

    <gj-modal
        size="1200_auto"
        v-bind="$attrs"
        v-on="$listeners"
        :loading="modalLoading"
        :visible.sync="modalVisible"
        class="multi-channel-order-modal"
    >
      <template #header>创建多渠道订单</template>
      <template #content>
        <div :hidden="step !== 0">
          <div >
            <el-form
                ref="formRef"
                :model="form"
                :label-position="'right'"
                label-width="106px"
            >
              <div>
                <gj-area-title>基本信息</gj-area-title>
                <el-row>
                  <el-col :span="8">
                    <el-form-item required label="店铺/国家" prop="marketId"
                                  :rules="[{ required: true, message: '请选择店铺国家', trigger: ['blur', 'change'] }]"
                    >
                      <gj-market-select
                          v-model="form.marketId"
                          width="220px"
                          :clearable="false"
                      >
                      </gj-market-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="卖家订单编号" prop="sellerFulfillmentOrderId"
                                  :rules="[{ required: true, message: '请输入卖家订单编号', trigger: ['blur', 'change'] }]"
                    >
                      <gj-input
                          v-model="form.sellerFulfillmentOrderId"
                          width="220px"
                      >
                      </gj-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="订单时间" prop="displayableOrderDateTime"
                                  :rules="[{ required: true, message: '请选择订单时间', trigger: ['blur', 'change'] }]"
                    >
                      <gj-date-picker
                          v-model="form.displayableOrderDateTime"
                          width="220px"
                          :clearable="false"
                      >
                      </gj-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <gj-area-title>收货信息</gj-area-title>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="国家" prop="countryCode"
                                  :rules="[{ required: true, message: '请选择国家', trigger: ['blur', 'change'] }]"
                    >
                      <gj-select
                          v-model="form.countryCode"
                          width="220px"
                          :options="pathCountry"
                          @change="getProvinceCode"
                      >
                      </gj-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item required label="地区" prop="stateOrProvinceCode"
                                  :rules="[{ required: true, message: '请输入区域', trigger: ['blur', 'change'] }]"
                    >
                      <el-autocomplete
                          class="inline-input"
                          v-model="form.stateOrProvinceCode"
                          style="width:220px"
                          size="mini"
                          clearable
                          :fetch-suggestions="querySearch"
                          placeholder="请输入内容"
                          :trigger-on-focus="true"
                          @select="handleSelect"
                      ></el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item required label="城市" prop="city"
                                  :rules="[{ required: true, message: '请输入城市', trigger: ['blur', 'change'] }]"
                    >
                      <gj-input
                          v-model="form.city"
                          width="220px"
                      >
                      </gj-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="收货地址1" prop="addressLine1"
                                  :rules="[{ required: true, message: '请输入收货地址', trigger: ['blur', 'change'] }]"
                    >
                      <gj-input
                          v-model="form.addressLine1"
                          width="220px"
                      >
                      </gj-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="收货地址2" prop="addressLine2">
                      <gj-input
                          v-model="form.addressLine2"
                          width="220px"
                      >
                      </gj-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="收货地址3" prop="addressLine3">
                      <gj-input
                          v-model="form.addressLine3"
                          width="220px"
                      >
                      </gj-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="邮编" prop="postalCode"
                                  :rules="[{ required: true, message: '请输入邮编', trigger: ['blur', 'change'] }]"
                    >
                      <gj-input
                          v-model="form.postalCode"
                          width="220px"
                      >
                      </gj-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="收货人姓名" prop="name"
                                  :rules="[{ required: true, message: '请输入收货人姓名', trigger: ['blur', 'change'] }]"
                    >
                      <gj-input
                          v-model="form.name"
                          width="220px"
                      >
                      </gj-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="电话" prop="phoneNumber">
                      <gj-input
                          v-model="form.phoneNumber"
                          width="220px"
                      >
                      </gj-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="卖家邮箱" prop="buyerEmail">
                      <gj-input
                          v-model="form.buyerEmail"
                          width="220px"
                      >
                      </gj-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="订单备注" prop="displayableOrderComment"
                                  :rules="[{ required: true, message: '请输入订单备注', trigger: ['blur', 'change'] }]"
                    >
                      <gj-textarea
                          v-model="form.displayableOrderComment"
                          :styles="{height: '32px', width: '220px'}"
                      >
                      </gj-textarea>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div>
                <el-row style="color: #666; padding-top: 8px; margin-bottom: 12px;">
                  <el-col :span="12">
                    <gj-area-title>订单商品</gj-area-title>
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <gj-button type="primary" @click="addGoods" :disabled="!form.marketId">添加商品</gj-button>
                  </el-col>
                </el-row>
                <gj-table
                    errorColumn
                    :columns="columns"
                    :data="form.items"
                    :show-pagination="false"
                    :adapt-height="false"
                    :min-height="200"
                    :show-overflow="false"
                    :height="350"
                    class="remove-margin-left"
                    :index="false"
                >
                  <template v-slot:marketId>
                    {{isMeaningful(form.marketId) ? marketMap[form.marketId].text : ''}}
                  </template>
                  <template v-slot:msku="{ row }">
                    <gj-tooltip :text-line="1" :content="row.title">
                      {{row.title}}
                    </gj-tooltip>
                    <el-row>
                      <el-col :span="11">
                        <el-row>
                          <gj-link :href="row.asinUrl" target="_blank">{{row.asin}}</gj-link>
                          <span v-copy="row.asin"
                                class="copy-icon gj-cell-display-switch">
                              <gj-icon class="el-icon-copy-document"></gj-icon>
                            </span>
                        </el-row>
                      </el-col>
                      <el-col :span="13">
                        <el-row>
                          <el-col :span="20">
                            <gj-tooltip :text-line="1" :content="row.msku">
                              {{row.msku || '-'}}
                            </gj-tooltip>
                          </el-col>
                          <el-col :span="4" v-if="row.msku">
                            <span v-copy="row.msku"
                                  class="copy-icon gj-cell-display-switch">
                              <gj-icon class="el-icon-copy-document"></gj-icon>
                            </span>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-slot:shipmentQuantity="{ index }">
                    <el-form-item class="gj-table-item" :prop="`items.${index}.quantity`"
                                  :rules="[
                            { required: true, message: '请输入发货数量', trigger: ['blur', 'change'] },
                        ]">
                      <gj-input
                          v-model.number="form.items[index].quantity"
                          placeholder="发货数量"
                          width="100%"
                      >
                      </gj-input>
                    </el-form-item>
                  </template>
                  <template v-slot:op="{ index }">
                    <gj-button type="text" @click="removeItem(index)">移除</gj-button>
                  </template>
                </gj-table>
              </div>
            </el-form>
          </div>
          <!--            <div style="text-align: center; padding-top: 20px ">-->
          <!--              -->
          <!--            </div>-->
        </div>

        <div :hidden="step !== 1">
          <div>
            <el-row style="padding-left: 12px; border: 1px solid #e8e8e8; height: 420px">
              <el-col :span="12" style="padding: 16px 0 16px 12px">
                <div class="shipment-title">
                  <div>
                    <gj-required></gj-required>
                    配送信息
                  </div>
                  <div class="shipment-content">
                    <el-radio v-model="shipmentType" :label="'Ship'">配送此库存</el-radio>
                    <el-radio v-model="shipmentType" :label="'Hold'">暂缓配送(订单配送可暂缓两周)</el-radio>
                  </div>
                </div>
                <!--                  <div class="shipment-title">-->
                <!--                    <div style="padding-left: 4px;">配送服务</div>-->
                <!--                    <div class="shipment-content"><el-checkbox v-model="shipmentServer">货到付款(COD)</el-checkbox></div>-->
                <!--                  </div>-->
                <div class="shipment-title">
                  <div>
                    <gj-required></gj-required>
                    航运速度
                  </div>
                  <div class="shipment-content">
                    <el-row v-for="(item, index) in preview.items"
                            :style="[index + 1 !== preview.items.length ? 'margin-bottom: 8px' : '']" :key="index">
                      <el-radio @change="changeShipping" v-model="shipmentSpeed" :label="item.shippingSpeedCategory">
                        {{item.shippingSpeedCategory}} {{item.latestArrivalDate}}
                      </el-radio>
                    </el-row>
                  </div>
                </div>
                <div class="shipment-speed-title">
                  <span class="shipment-speed-content">
                      <el-row>预计最早发货日期：{{previewItem.earliestShipDate}}</el-row>
                      <el-row>预计最迟发货日期：{{previewItem.earliestArrivalDate}}</el-row>
                      <el-row>预计最早送达日期：{{previewItem.latestShipDate}}</el-row>
                      <el-row>预计最迟送达日期：{{previewItem.latestShipDate}}</el-row>
                    </span>
                </div>
              </el-col>
              <el-col :span="12" style="border-left: 1px solid #e8e8e8; padding: 12px 24px; height: 100%">
                <div class="preview-content">
                  <div class="preview-title" style="color: #cc6600">订单一览</div>
                  <div class="preview-content-label">
                    <label class="preview-label">卖家订单编号: </label>
                    <label class="preview-value">{{form.sellerFulfillmentOrderId}}</label>
                  </div>
                </div>

                <div class="preview-content">
                  <div class="preview-title">配送地址</div>
                  <div class="preview-content-label">
                    <label class="preview-value">{{form.addressLine1}}</label>
                  </div>
                </div>

                <div class="preview-content">
                  <div class="preview-title">配送一览</div>
                  <div class="preview-content-label">
                    <label class="preview-label">航运速度: </label>
                    <label class="preview-value">{{shipmentSpeed}}</label>
                  </div>
                  <div class="preview-content-label">
                    <label class="preview-label">预计重量: </label>
                    <label class="preview-value">{{previewItem.estimatedShippingWeight ||
                      '-'}}{{previewItem.estimatedShippingWeightUnit || ''}}</label>
                  </div>
                </div>

                <div class="preview-content">
                  <div class="preview-title">预计费用</div>
                  <div class="preview-content-label">
                    <label class="preview-label">基础服务费: </label>
                    <label class="preview-value">{{initAmount(previewItem.fbaPerUnitFulfillmentFee || '-')}}</label>
                  </div>
                  <div class="preview-content-label">
                    <label class="preview-label">估算的订单总计: </label>
                    <label class="preview-value">{{estimateTotal()}}</label>
                  </div>
                </div>

                <div class="preview-content">
                  <div class="preview-title">装箱单</div>
                  <div class="preview-content-label">
                    <label class="preview-label">订单日期: </label>
                    <label class="preview-value">{{initDisplayableOrderDateTime()}}</label>
                  </div>
                  <div class="preview-content-label">
                    <label class="preview-label">备注: </label>
                    <label class="preview-value">{{form.displayableOrderComment}}</label>
                  </div>
                </div>
              </el-col>
            </el-row>
            <gj-area-title style="margin-top: 20px">订单商品</gj-area-title>
            <gj-table
                errorColumn
                :data="form.items"
                :show-pagination="false"
                :columns="previewColumns"
                :adapt-height="false"
                :index="false"
                :min-height="200"
                :show-overflow="false"
                :height="350"
            >
              <template v-slot:marketId>
                {{isMeaningful(form.marketId) ? marketMap[form.marketId].text : ''}}
              </template>
              <template v-slot:msku="{ row }">
                <gj-tooltip :text-line="1" :content="row.title">
                  {{row.title}}
                </gj-tooltip>
                <el-row>
                  <el-col :span="11">
                    <el-row>
                      <el-col :span="18">
                        <gj-link :href="row.asinUrl" target="_blank">
                          {{row.asin}}
                        </gj-link>
                      </el-col>
                      <el-col :span="4" v-if="row.asin">
                      <span v-copy="row.asin"
                            class="copy-icon gj-cell-display-switch">
                        <gj-icon class="el-icon-copy-document"></gj-icon>
                      </span>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="13">
                    <el-row>
                      <el-col :span="20">
                        <gj-tooltip :text-line="1" :content="row.msku">
                          {{row.msku || '-'}}
                        </gj-tooltip>
                      </el-col>
                      <el-col :span="4" v-if="row.msku">
                            <span v-copy="row.msku"
                                  class="copy-icon gj-cell-display-switch">
                              <gj-icon class="el-icon-copy-document"></gj-icon>
                            </span>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </template>
            </gj-table>
          </div>
          <!--            <div style="text-align: center; padding-top: 20px ">-->
          <!--              -->
          <!--            </div>-->
        </div>
      </template>
      <template #footer>
        <template v-if="step === 0">
          <gj-button @click.stop="cancel">取消</gj-button>
          <gj-button type="primary" @click.stop="next" :loading="loading">下一步</gj-button>
        </template>
        <template v-if="step === 1">
          <gj-button @click.stop="cancel">取消</gj-button>
          <gj-button @click.stop="pre">上一步</gj-button>
          <gj-button type="primary" @click.stop="confirm" :loading="loading">确定</gj-button>
        </template>
      </template>
    </gj-modal>
  </div>
</template>

<script>
  import {isMeaningfulMixin, modalMixIn} from "../../../../../minxins";
  import AddGoods from "./add-goods";
  import {createFulfillmentPreview, getFulfillmentPreview, getFindAllCountry, getFindProvinceByCountryCode, getFulfillmentOrder} from "@/api/sale";
  import {pathCountry} from "@/utils/options";
  import {convertToDate} from "@/utils/date.util";
  import {isMeaningful, isMeaningless, transformToMap} from "@/utils/common";
  import {mapGetters} from "vuex";

  export default {
    name: "add-multi-channel-order",
    mixins: [modalMixIn, isMeaningfulMixin],
    computed: {
      ...mapGetters({
        marketMap: 'marketMap',
      }),
    },
    props: {
      id: {
        default: null
      }
    },
    created() {
      this.getFulfillmentOrder(this.id)
      this.getAllCountry();
    },
    data() {
      return {
        loading: false,
        modalLoading: false,
        item: null,
        step: 0,
        form: {
          marketId: null,
          sellerFulfillmentOrderId: null,
          displayableOrderDateTime: new Date(),
          countryCode: null,
          stateOrProvinceCode: null,
          city: null,
          addressLine1: null,
          addressLine2: null,
          addressLine3: null,
          postalCode: null,
          name: null,
          phoneNumber: null,
          buyerEmail: null,
          displayableOrderComment: 'Thank you for your order!',
          items: [
            // {
            //     asin:  null,
            //     asinUrl:  null,
            //     availableQuantity:  null,
            //     imageUrl:  null,
            //     msku:  null,
            //     quantity:  null,
            //     sku:  null,
            //     title:  null,
            // }
          ],
        },
        columns: [
          {id: 'marketId', header: '店铺/国家', field: 'slot:marketId', minWidth: '150px', default: true},
          {id: 'imageUrl', header: '图片', field: 'picture:imageUrl', minWidth: '60px', default: true},
          {id: 'msku', header: '商品标题/ASIN/MSKU', field: 'slot:msku', minWidth: '350px', default: true},
          {
            id: 'availableQuantity',
            header: '可用库存',
            field: 'availableQuantity',
            minWidth: '80px',
            default: true,
            align: 'right'
          },
          {
            id: 'quantity',
            header: '发货数量',
            field: 'slot:shipmentQuantity',
            minWidth: '100px',
            default: true,
            align: 'right'
          },
          {id: 'op', header: '操作', field: 'slot:op', minWidth: '80px', default: true, notCustomColumn: true},
        ],
        previewColumns: [
          {id: 'marketId', header: '店铺/国家', field: 'slot:marketId', minWidth: '150px', default: true},
          {id: 'imageUrl', header: '图片', field: 'picture:imageUrl', minWidth: '60px', default: true},
          {id: 'msku', header: '商品标题/ASIN/MSKU', field: 'slot:msku', minWidth: '350px', default: true},
          {
            id: 'availableQuantity',
            header: '可用库存',
            field: 'availableQuantity',
            minWidth: '80px',
            default: true,
            align: 'right'
          },
          {id: 'quantity', header: '发货数量', field: 'quantity', minWidth: '100px', default: true, align: 'right'},
          {id: 'op', header: '操作', field: 'slot:op', minWidth: '80px', default: true, notCustomColumn: true},
        ],
        pathCountry: [],
        areaList: [],
        shipmentType: 'Ship',
        shipmentServer: true,
        shipmentSpeed: 'Standard',
        // 预览对象
        preview: {items: []},
        previewItemsMap: null,
        previewItem: {},
      }
    },
    methods: {
      getFulfillmentOrder(id) {
        if (id) {
          this.modalLoading = true
          getFulfillmentOrder(id)
            .then((res) => {
              this.item = res
              if (this.item !== null) {
                for (let key in this.item) {
                  if (isMeaningful(this.item[key])) {
                    if (key === 'marketId') {
                      this.form.marketId = this.item[key] + '';
                    } else {
                      this.form[key] = this.item[key];
                    }
                  }
                }
                this.getProvinceCode();
              }
            })
            .complete(() => this.modalLoading = false)
        }
      },
      querySearch(queryString, cb) {
        let filterRestaurants = null;
        if (isMeaningful(queryString)) {
          filterRestaurants = this.areaList.filter(restaurant => restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0)
        }
        let results = queryString ? filterRestaurants : this.areaList; // 调用 callback 返回建议列表的数据
        cb(results);
      },
      // 选择后赋值
      handleSelect(item){
        this.form.stateOrProvinceCode = item.value;
      },
      getAllCountry(){
        getFindAllCountry().then(res => {
            res.forEach( item =>{
              item.id = item.countryCode;
              item.text = item.nameCn +'-'+ item.countryCode;
            })
          this.pathCountry = res;
          this.areaList = [];
        })
      },
      getProvinceCode(){
        if(this.form.countryCode){
          getFindProvinceByCountryCode(this.form.countryCode).then(res =>{
             let list = [];
             res.forEach(item => {
                list.push({label: item, value: item })
              })
             this.areaList =list;
          })
        }
      },
      removeItem(index) {
        this.form.items.splice(index, 1);
      },
      next() {
        if (!this.form.items.length) {
          this.$message.warning('请先添加商品')
          return
        }
        this.loading = true;

        const self = this;

        if (this.formValidate() && this.form.items.length !== 0) {
          getFulfillmentPreview({
            ...this.form,
            displayableOrderDateTime: convertToDate(this.form.displayableOrderDateTime)
          }).then((data) => {
              self.preview = data;
              if (data.items && data.items.length > 0) {
                self.previewItemsMap = transformToMap(data.items, 'shippingSpeedCategory');
                self.changeShipping();   //默认选中标准航运
              }
              self.step = 1;
            }).complete(() => self.loading = false)
        } else {
          this.loading = false;
        }
      },
      pre() {
        this.step = 0;
      },
      confirm() {
        this.loading = true;
        createFulfillmentPreview({
          ...this.form,
          displayableOrderDateTime: convertToDate(this.form.displayableOrderDateTime),
          shippingSpeedCategory: this.shipmentSpeed,
          fulfillmentAction: this.shipmentType
        }).then(() => {
          this.$gjMessage.success('操作成成功');
          this.$emit('after')
        }).complete(() => this.loading = false)
      },
      addGoods() {
        const vm = this;
        const modal = this.$gjCreate(AddGoods, {
          props: {
            marketId: this.form.marketId,
          },
          on: {
            after(selectedRows) {
              if (selectedRows && selectedRows.length > 0) {
                selectedRows.forEach(v => {
                  if (!vm.form.items.some(k => k.msku === v.msku)) {
                    vm.form.items.push({...v, quantity: 1});
                  }
                })
              }
              modal.$gjDestroy();
            }
          },
        })
      },
      changeShipping() {
        this.previewItem = this.previewItemsMap[this.shipmentSpeed]
      },
      formValidate() {
        let formValid = false;
        this.$refs.formRef.validate((valid) => {
          formValid = valid;
        });
        if (formValid && this.checkQuantity(this.form.items)) {
          return;
        }
        return formValid;
      },
      initAmount(amount) {
        if (isMeaningful(amount)) {
          return this.preview.currencySymbol + amount;
        } else {
          return '-';
        }
      },
      estimateTotal() {
        let amount = 0;
        if (this.previewItem) {
          if (isMeaningful(this.previewItem.fbaPerOrderFulfillmentFee)) {
            amount += Number(this.previewItem.fbaPerOrderFulfillmentFee);
          }
          if (isMeaningful(this.previewItem.fbaFulfillmentCODFee)) {
            amount += Number(this.previewItem.fbaFulfillmentCODFee);
          }
          if (isMeaningful(this.previewItem.fbaPerUnitFulfillmentFee)) {
            amount += Number(this.previewItem.fbaPerUnitFulfillmentFee);
          }
          if (isMeaningful(this.previewItem.fbaTransportationFee)) {
            amount += Number(this.previewItem.fbaTransportationFee);
          }
        }
        return this.initAmount(amount)
      },
      initDisplayableOrderDateTime() {
        if (this.form.displayableOrderDateTime && this.form.displayableOrderDateTime instanceof Date) {
          return convertToDate(this.form.displayableOrderDateTime);
        } else if (this.form.displayableOrderDateTime) {
          return this.form.displayableOrderDateTime;
        }
        return '';
      },
      checkQuantity(items) {
        let flag = false;
        items.forEach(v => {
          const text = /^[1-9]\d*$/;
          if (isMeaningless(v.quantity) || isNaN(v.quantity) || Number(v.quantity) <= 0 || !text.test(v.quantity)) {
            flag = true;
          }
        });
        if (flag) {
          this.$gjMessage.error('请输入正确的发货数量');
        }
        return flag;
      }
    }
  }
</script>

<style lang="scss" scoped>

  .shipment-title {
    padding: 0 0 20px 8px;
  }

  .shipment-content {
    padding: 16px 0 0 16px;
  }

  .shipment-speed-title {
    padding-left: 18px;
  }

  .shipment-speed-content {
    background: #ccebff;
    border: 1px solid #0099ff;
    display: inline-block;
    line-height: 1.6;
    padding: 12px;
  }

  .remove-margin-left {
    max-height: 350px;
  }

  .remove-margin-left /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  /deep/ .el-link {
    font-weight: unset;
  }

  .preview-title {
    border-bottom: 1px solid #e8e8e8;
  }

  .preview-content {
    margin-bottom: 20px;
  }

  .preview-label {
    color: #666;
  }

  .preview-value {
    color: #333;
  }

  .preview-content-label {
    margin-top: 4px;
  }

  /deep/ .el-dialog__footer {
    text-align: center;
  }
  .multi-channel-order-modal /deep/ .el-dialog__body{
    padding-bottom: 0;
    padding: 16px 12px;
  }
  .el-autocomplete{
    /deep/ .el-input--mini .el-input__inner{
      height: 32px !important;
    }
  }
</style>
